<template>
    <div>
        <img :src="getSrc" alt="photo"/>
    </div>
</template>
<script>
export default {
  props: ['row', 'value'],
  computed: {
    getSrc() {
            if (this.$attrs.xprops.fromByteArray === true) {
                return "data:image/png;base64," + this.value;
            } else {
                this.value;
            }
        }
    }
}
</script>
<style scoped>
img {
    width: auto;
    height: auto;
    max-height: 120px;
    max-width: 120px;
}
</style>